import { render, staticRenderFns } from "./total-chart.vue?vue&type=template&id=d837f990&"
import script from "./total-chart.vue?vue&type=script&lang=js&"
export * from "./total-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports